import React from 'react'

export default function Triangle() {
    return (
        <svg width="30" height="30" viewBox="0 0 68 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.7417 6.5C27.7454 -2.16666 40.2546 -2.16667 45.2583 6.5L66.0429 42.5C71.0466 51.1667 64.792 62 54.7846 62H13.2154C3.20799 62 -3.04664 51.1667 1.95706 42.5L22.7417 6.5Z" fill="#EB5757" />
        </svg>
    )
}
